import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/styles/index.css";
import "@/styles/print.css";
import { App } from "./App";

// Após deploy, chunks antigos podem falhar — recarrega uma vez para pegar o build novo.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const key = "vite-chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
